import { apiRequest } from '../apiRequest';

export const deleteTelegramDestinationApi = async (id) => {
  return apiRequest('/admin/notification/telegram-destinations/' + id, {
    method: 'DELETE',
    defaultErrorMessage: 'Failed to delete Telegram destination',
  });
};
